// Fichier : src/pages/rapports/doublons.js (Nouveau fichier)
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Table, Button, Spin, Empty, Alert, Tag, Popconfirm, message } from 'antd';
import { findDuplicateRapports } from '../../redux/slices/rapports/rapportsThunk';
import { deleteRapport } from '../../redux/slices/rapports/rapportsThunk'; // réutiliser le thunk existant
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; // <-- AJOUTER CET IMPORT
dayjs.extend(utc); // <-- AJOUTER CETTE LIGNE pour activer le plugin

const RapportsDoublonsPage = () => {
  const dispatch = useDispatch();
  const { data: duplicateGroups, loading, error } = useSelector((state) => state.rapports.duplicates);
  const { deleteLoading } = useSelector((state) => state.rapports);

  useEffect(() => {
    dispatch(findDuplicateRapports());
  }, [dispatch]);

  const handleDelete = async (rapportId) => {
    try {
      await dispatch(deleteRapport(rapportId)).unwrap();
      message.success('Rapport supprimé avec succès !');
      // Re-fetch la liste des doublons pour mettre à jour l'interface
      dispatch(findDuplicateRapports());
    } catch (err) {
      message.error(`Erreur lors de la suppression : ${err}`);
    }
  };

  const columns = [
    {
      title: 'Délégué',
      dataIndex: ['reports', 0, 'delegate'],
       render: (delegate) => `${delegate?.user?.firstName || ''} ${delegate?.user?.lastName || ''}`,
    },
    {
      title: 'Médecin Visité',
      dataIndex: ['reports', 0, 'person'],
      render: (person) => `${person?.firstname || ''} ${person?.lastname || ''}`,
    },
    {
      title: 'Date de Visite',
      dataIndex: 'visitDate',
      render: (date) => dayjs(date).format('DD/MM/YYYY'),
    },
    {
      title: 'Nombre de Rapports',
      dataIndex: 'count',
      render: (count) => <Tag color="red">{count}</Tag>,
    },
  ];

  const expandedRowRender = (record) => {
    const nestedColumns = [
      { title: 'ID Rapport', dataIndex: 'id', key: 'id' },
      { 
        title: 'Heure Soumission', 
        dataIndex: 'submissionTimestamp', 
        key: 'submissionTimestamp', 
        render: (date) => date ? dayjs.utc(date).format('HH:mm:ss') : 'N/A' 
      },
      { title: 'Note', dataIndex: 'note', key: 'note', ellipsis: true },
      {
        title: 'Action',
        key: 'action',
        render: (_, report) => (
          <Popconfirm
            title="Êtes-vous sûr de vouloir supprimer ce rapport ?"
            onConfirm={() => handleDelete(report.id)}
            okText="Oui"
            cancelText="Non"
          >
            <Button type="primary" danger loading={deleteLoading}>
              Supprimer
            </Button>
          </Popconfirm>
        ),
      },
    ];

    return <Table columns={nestedColumns} dataSource={record.reports} pagination={false} rowKey="id" />;
  };

  if (loading) return <Spin tip="Recherche des doublons..." />;
  if (error) return <Alert message="Erreur" description={error} type="error" />;

  return (
    <Card title="Gestion des Rapports en Double">
      <Table
        columns={columns}
        dataSource={duplicateGroups}
        rowKey={(record) => `${record.delegateId}-${record.personId}-${record.visitDate}`}
        expandable={{ expandedRowRender }}
        pagination={{ pageSize: 20 }}
        locale={{ emptyText: <Empty description="Aucun rapport en double trouvé. Bravo !" /> }}
      />
    </Card>
  );
};

export default RapportsDoublonsPage;